import { render } from "./licences_permits_certifications.html?vue&type=template&id=1a8c0b52&external"
import script from "./licences_permits_certifications.js?vue&type=script&lang=js&external"
export * from "./licences_permits_certifications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__